import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSessionId } from "../../../../../../utils/tokenHandlers";
import { getAllDueDiligenceDoc } from "../../apis/getAllDueDilligenceDoc";

export const getAllDueDiligenceDocAction = createAsyncThunk(
  "getAllDueDiligenceDocAction",
  async (customerId: number) => {
    return getAllDueDiligenceDoc(customerId, getSessionId()).then(
      (response: any) => {
        return response.data;
      }
    );
  }
);
